module.exports = __webpack_public_path__ + "img/logo24.56d9a559.jpg";